import { default as domainCatalogGrid } from './grid/routes'

export default [
    ...domainCatalogGrid
]
